import { atom, type WritableAtom } from 'nanostores';
import type { Message } from '@ai-sdk/ui-utils';

export class ChatStore {
  chat: WritableAtom<Array<Message>>;
  initialPrompt: WritableAtom<string | undefined> = atom<string | undefined>(undefined);

  kickStartChat: WritableAtom<boolean> = atom<boolean>(false);

  updateMessage: WritableAtom<
    | {
        message: string;
        directive?: string;
        role?: 'user' | 'system' | 'data';
        type?: string;
        resetDeploymentAttempts?: boolean;
      }
    | undefined
  > = atom<
    | {
        message: string;
        directive?: string;
        role?: 'user' | 'system' | 'data';
        type?: string;
        resetDeploymentAttempts?: boolean;
      }
    | undefined
  >(undefined);
  messageReady: WritableAtom<boolean> = atom<boolean>(false);

  constructor() {
    this.chat = atom<Array<Message>>([]);
  }

  setKickStartChat(value: boolean) {
    this.kickStartChat.set(value);
  }

  setInitialPrompt(prompt: string | undefined) {
    this.initialPrompt.set(prompt);
  }

  saveMessages(messages: Array<Message>) {
    this.chat.set(messages);
  }

  onMessageReady(value: boolean) {
    this.messageReady.set(value);
  }

  onAppendMessage({
    message,
    directive,
    role,
    type,
    resetDeploymentAttempts,
  }: {
    message: string;
    directive?: string;
    role?: 'user' | 'system' | 'data';
    type?: string;
    resetDeploymentAttempts?: boolean;
  }) {
    this.updateMessage.set({
      role,
      message,
      directive,
      type,
      resetDeploymentAttempts,
    });
  }

  reset() {
    this.chat.set([]);
    this.initialPrompt.set(undefined);
    this.kickStartChat.set(false);
  }
}
